import React, { useEffect, useState } from "react";
import { Link, useLocation, useNavigate } from "react-router-dom";
import "./TopNav.css";

const LINKS = [
  { id: "teaching", label: "Teaching" },
  { id: "work", label: "Work" },
  { id: "resources", label: "Resources" },
  { id: "writings", label: "Writings" },
  { id: "newsletter", label: "Newsletter" },
  { id: "contact", label: "Contact" },
];

function TopNav() {
  const [scrolled, setScrolled] = useState(false);
  const [menuOpen, setMenuOpen] = useState(false);
  const location = useLocation();
  const navigate = useNavigate();

  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 8);
    onScroll();
    window.addEventListener("scroll", onScroll, { passive: true });
    return () => window.removeEventListener("scroll", onScroll);
  }, []);

  useEffect(() => {
    setMenuOpen(false);
  }, [location.pathname, location.hash]);

  useEffect(() => {
    if (menuOpen) {
      const prev = document.body.style.overflow;
      document.body.style.overflow = "hidden";
      return () => {
        document.body.style.overflow = prev;
      };
    }

    document.body.style.overflow = "";
  }, [menuOpen]);

  useEffect(() => {
    const unlockScroll = () => {
      if (!menuOpen) document.body.style.overflow = "";
    };

    window.addEventListener("pageshow", unlockScroll);
    window.addEventListener("focus", unlockScroll);
    document.addEventListener("visibilitychange", unlockScroll);

    return () => {
      window.removeEventListener("pageshow", unlockScroll);
      window.removeEventListener("focus", unlockScroll);
      document.removeEventListener("visibilitychange", unlockScroll);
    };
  }, [menuOpen]);

  useEffect(() => {
    const onKey = (e) => {
      if (e.key === "Escape") setMenuOpen(false);
    };
    if (menuOpen) window.addEventListener("keydown", onKey);
    return () => window.removeEventListener("keydown", onKey);
  }, [menuOpen]);

  const goToSection = (id) => {
    if (location.pathname === "/") {
      const el = document.getElementById(id);
      if (el) el.scrollIntoView({ behavior: "smooth", block: "start" });
    } else {
      navigate(`/#${id}`);
    }
  };

  const handleSectionClick = (e, id) => {
    e.preventDefault();
    setMenuOpen(false);
    goToSection(id);
  };

  const handleBrandClick = (e) => {
    setMenuOpen(false);
    if (location.pathname === "/") {
      e.preventDefault();
      window.scrollTo({ top: 0, behavior: "smooth" });
    }
  };

  const navClass = [
    "topnav",
    scrolled || menuOpen ? "topnav--scrolled" : "",
    menuOpen ? "topnav--menu-open" : "",
  ]
    .filter(Boolean)
    .join(" ");

  return (
    <>
      <header className={navClass}>
        <div className="topnav__inner">
          <Link
            to="/"
            className="topnav__brand"
            onClick={handleBrandClick}
            aria-label="Daniel Sumah — home"
          >
            Daniel Sumah
          </Link>

          <nav className="topnav__links" aria-label="Primary">
            {LINKS.map((l) => (
              <a
                key={l.id}
                href={`/#${l.id}`}
                className="topnav__link"
                onClick={(e) => handleSectionClick(e, l.id)}
              >
                {l.label}
              </a>
            ))}
          </nav>

          <button
            type="button"
            className={
              "topnav__burger" + (menuOpen ? " topnav__burger--open" : "")
            }
            aria-label={menuOpen ? "Close menu" : "Open menu"}
            aria-expanded={menuOpen}
            aria-controls="topnav-mobile"
            onClick={() => setMenuOpen((v) => !v)}
          >
            <span />
            <span />
            <span />
          </button>
        </div>
      </header>

      <div
        id="topnav-mobile"
        className={
          "topnav__mobile" + (menuOpen ? " topnav__mobile--open" : "")
        }
        aria-hidden={!menuOpen}
      >
        <nav className="topnav__mobile-nav" aria-label="Primary (mobile)">
          {LINKS.map((l, i) => (
            <a
              key={l.id}
              href={`/#${l.id}`}
              className="topnav__mobile-link"
              style={{
                transitionDelay: menuOpen ? `${0.05 + i * 0.04}s` : "0s",
              }}
              onClick={(e) => handleSectionClick(e, l.id)}
            >
              {l.label}
            </a>
          ))}
        </nav>
      </div>
    </>
  );
}

export default TopNav;
